module.exports = __webpack_public_path__ + "media/images/european-festival-hover 2-b3dbb1f423b2c31e364b160f629892e1.png";